<template>
  <div class="main">
    <report-top>
      <template slot="search">
        <ly-search v-model="searchItem.keyWork" @search="search"></ly-search>
      </template>
    </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">项目名称</p>
        <div style="width: 120px">
          <selectItems
            :name="searchItem.groupName"
            @update:name="searchItem.groupName = $event"
            :id="searchItem.groupId"
            @update:id="searchItem.groupId = $event"
            clearable
          ></selectItems>
        </div>
      </div>

      <div class="formTableItem">
        <p class="label">所属部门</p>
        <selectGroup
          :name="searchItem.deptName"
          @update:name="searchItem.deptName = $event"
          :id="searchItem.deptId"
          @update:id="searchItem.deptId = $event"
          clearable
        >
        </selectGroup>
      </div>
      <div class="formTableItem">
        <p class="label">业务类型</p>
        <Select
          v-model="searchItem.businessType"
          clearable
          style="width: 120px"
          @on-clear="searchItem.businessType = ''"
        >
          <Option
            v-for="(x, index) in $t('businessType')"
            :value="x"
            :key="index"
            >{{ x }}</Option
          >
        </Select>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" size="small" class="chaxun">立即查询</Button>
        <Button
          @click="openAdd"
          type="primary"
          size="small"
          style="margin-left: 4px"
          >新增记录</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="classes123">
        <ul @click="openClasses(row)">
          <li v-for="(item, index2) in row.myclass" :key="index2">
            {{ item.name }}：
            <span v-for="(x, index3) in item.timeList" :key="index3"
              >{{ x.startTime }}-{{ x.endTime }}
            </span>
            ({{ item.manNum }}人)
          </li>
        </ul>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增作业计划' : '编辑作业计划'"
      footer-hide
      width="700"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="选择班次" prop="classId">
              <Select v-model="item.classId" @on-select="selectCalsses">
                <Option
                  v-for="(x, index) in classesList"
                  :value="x.id"
                  :key="index"
                  >{{ x.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>

          <Col span="12">
            <FormItem label="项目名称" prop="groupId">
              <selectItems
                :name="item.groupName"
                @update:name="item.groupName = $event"
                :id="item.groupId"
                @update:id="item.groupId = $event"
              ></selectItems>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="所属部门" prop="deptName">
              <selectGroup
                :name="item.deptName"
                @update:name="item.deptName = $event"
                :id="item.deptId"
                @update:id="item.deptId = $event"
                placement="left"
              >
              </selectGroup>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="业务类型" prop="businessType">
              <Select v-model="item.businessType">
                <Option
                  v-for="(x, index) in $t('businessType')"
                  :value="x"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>

          <Col span="12">
            <FormItem label="开始日期" prop="startDate1">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.startDate1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="结束日期" prop="endDate1">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.endDate1"
              ></DatePicker>
            </FormItem>
          </Col>
          
          <Col span="12">
            <FormItem label="备注" prop="remark">
              <Input v-model="item.remark" placeholder="请输入"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="next('item')">下一步</Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <Modal
      v-model="openNextForm"
      footer-hide
      fullscreen
      @on-cancel="cliclCancelBtn"
    >
      <h2>人员安排</h2>
      <renyuanList ref="renyuanList"></renyuanList>
      <Row type="flex" justify="end">
        <Col span="24">
          <div class="btn-wrap">
            <Button @click="prev">上一步</Button>
            <Button type="primary" @click="addUpdate">提交表单</Button>
          </div>
        </Col>
      </Row>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import renyuanList from "./renyuanList.vue";

export default {
  components: { renyuanList },
  data() {
    return {
      openForm: false,
      openNextForm: false,
      isAdd: false,
      fresh: false, //点击下一步是否清空班次
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "名称",
          key: "name",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "业务类型",
          key: "businessType",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "项目名称",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "部门名称",
          key: "deptName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "排班表",
          slot: "classes123",
          minWidth: 220,
          maxWidth: 300,
        },
        {
          title: "开始日期",
          key: "createTime",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startDate, "yymmdd"));
          },
        },
        {
          title: "结束日期",
          key: "createTime",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endDate, "yymmdd"));
          },
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建者账号",
          minWidth: 100,
          maxWidth: 200,
          key: "createAccount",
        },
        {
          title: "创建时间",
          key: "createTime",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: "",
        groupName: "",
        deptId: "",
        deptName: "",
        name: "",
        businessType: "清扫保洁",
        startDate: 1665504000000,
        startDate1: "",
        endDate: 1666281600000,
        endDate1: "",
        remark: "",
        classesList: [
          {
            classes: [
              {
                classesTimeId: 76,
                name: "A班",
                type: "",
                //scheduleId: 0,
                timeList: [
                  {
                    startTime: "09:00",
                    endTime: "10:30",
                  },
                  {
                    startTime: "09:00",
                    endTime: "10:00",
                  },
                ],
                userIds: [],
                manNum: 3,
              },
              {
                classesTimeId: 77,
                name: "B班",
                type: "",
                //scheduleId: 0,
                timeList: [
                  {
                    startTime: "09:00",
                    endTime: "10:30",
                  },
                  {
                    startTime: "09:00",
                    endTime: "10:00",
                  },
                ],
                userIds: [],
                manNum: 3,
              },
            ],
            manager: "",
            tel: "",
            vacationDay: 3,
            cdate: 1665504000000,
          },
        ],
        classId: "",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        groupId: { required: true, message: "必填" },
        startDate1: { required: true, message: "必填" },
        endDate1: { required: true, message: "必填" },
        businessType: { required: true, message: "必填" },
        deptName: { required: true, message: "必填" },
      },
      total: 0,
      split: 0.2,
      searchItem: {
        pageNumber: 1,
        keyWork: "",
        groupId: "",
        groupName: "",
        name: "",
        deptId: "",
        deptName: "",
        pageSize: 50,
        businessType: "",
      },
      classesList: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/schedule/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].myclass = data[i].classesList[0].classes;
          data[i].startDate1 = this.utils.sjcTo(data[i].startDate);
          data[i].endDate1 = this.utils.sjcTo(data[i].endDate);
          data[i].classId = data[i].classesId[0];
        }

        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.renyuanList.readData();
      this.item.classesList = a;
      this.item.classesId = [this.item.classId];
      console.log(this.item);
      if (this.isAdd) {
        axios({
          method: "post",
          url: axios.swm + "/schedule/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.openForm = false;
            this.openNextForm = false;
            this.getList();
          }
        });
      } else {
        axios({
          method: "post",
          url: axios.swm + "/schedule/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.openForm = false;
            this.openNextForm = false;
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.swm + "/schedule/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      //var a=x.split(',');
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
      this.item.classesId = 14;

      console.log(this.item);
    },
    openClasses(row) {
      this.item = row;
      this.next("item");
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    next(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var a = this.utils.toSjc(this.item.startDate1);
          var b = this.utils.toSjc(this.item.endDate1);
          if (a > b) {
            this.$Message.error("时间设置不合理");
            return;
          }
          if (this.item.startDate != a || this.item.endDate != b) {
            console.log("时间变了");
            this.item.startDate = a;
            this.item.endDate = b;
            this.fresh = true;
          } else {
            console.log("时间不变");

            this.fresh = false;
          }
          this.openForm = false;
          this.openNextForm = true;
          this.getPerson(this.item.deptId);
        }
      });
    },
    prev() {
      this.openForm = true;
      this.openNextForm = false;
    },
    getPerson(id) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.dm + "/person/list",
        data: { groupIdList: [id] },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        var users = [];
        for (let i = 0; i < data.length; i++) {
          var obj = {
            userId: String(data[i].id),
            name: data[i].name,
          };
          users.push(obj);
        }
        this.$refs.renyuanList.reData({
          persons: users,
          classesList: this.item.classesList,
          start: this.item.startDate,
          end: this.item.endDate,
          fresh: this.fresh,
        });
      });
    },
    getClasses() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/classes/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          for (const j in data[i].classesTimeList) {
            data[i].classesTimeList[j].userIds = [];
            data[i].classesTimeList[j].classesTimeId =
              data[i].classesTimeList[j].id;
          }
        }
        this.classesList = data;
      });
    },
    chaxun() {
      this.getList();
    },
    search() {
      this.getList();
    },
    selectCalsses(v) {
      console.log(v);
      this.item.name = v.label;
      var a = this.classesList;
      for (const i in a) {
        if (a[i].id == v.value) {
          for (const j in this.item.classesList) {
            this.item.classesList[j].classes = a[i].classesTimeList;
            this.item.classesList[j].manager = a[i].manager;
            this.item.classesList[j].classesId = a[i].id;
            this.item.classesList[j].tel = a[i].tel;
            this.item.classesList[j].vacationDay = a[i].vacationDay;
          }
        }
      }
    },
  },
  mounted() {
    this.chaxun();
    this.getClasses();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/person/zyjh.vue